import styled from 'styled-components';
import {textColorLight} from 'styles/constants';

// useful for common text tyle changes ad hoc

export default styled.span`
	color: ${({light}) => (light ? textColorLight : 'inherit')};
`;
